import { role } from '../../../../../libs'
import {
  buttonColorTransactionRequestStatus,
  humanTransactionRequestStatus,
  humanTransactionRequestStatusButton,
  statusWithdrawalFlow,
  transactionRequestStatus,
} from '../../../const'
import { RollbackModal } from '../RollbackModal'
import { QuestionModal } from '../HasQuestionModal'
import { MissingInformationModal } from '../MissingInformationModal'
import { RejectModal } from '../RejectModal'
import { Button, Modal, Tag } from 'antd'
import { submitStatus } from '../../edit/model'
import * as React from 'react'
import { WithdrawalEdit } from '../../edit'
import { UserRole } from '../../../../../features/user'
import { Guard } from '../../../../../features/session/guard'

type Props = {
  withdrawal: WithdrawalEdit
  userRole: UserRole | null
  actionLoading?: boolean
}

export const StatusPanel = ({ withdrawal, userRole, actionLoading }: Props) => {
  return (
    <>
      <Tag
        style={{
          color: buttonColorTransactionRequestStatus(withdrawal.status).text,
          backgroundColor: buttonColorTransactionRequestStatus(
            withdrawal.status,
          ).background,
          display: 'inline-flex',
          alignItems: 'center',
        }}
        title={withdrawal.status}
      >
        {humanTransactionRequestStatus(withdrawal.status)}
      </Tag>
      <Guard permission="edit_tranasaction_status">
        <>
          {userRole != undefined &&
            userRole.indexOf(role.clientSupport.supportAgent()) == -1 &&
            userRole.indexOf(role.clientSupport.supportManager()) == -1 &&
            statusWithdrawalFlow(
              withdrawal.status,
              withdrawal.mtTransactionId,
            )?.map((item, index) => {
              if (item === transactionRequestStatus.ps() && withdrawal.isCard) {
                return null
              }
              if (
                item === transactionRequestStatus.accepted() &&
                withdrawal.gateway?.processingProvider == 'manual' &&
                withdrawal.gateway?.paymentMethodType == 'exchanger'
              ) {
                return null
              }
              if (item === transactionRequestStatus.rollback()) {
                return <RollbackModal key={item} className="ms-2" request={withdrawal} disabled={actionLoading} />
              }
              if (item === transactionRequestStatus.questions()) {
                return <QuestionModal key={item} className="ms-2" request={withdrawal} disabled={actionLoading} />
              }
              if (item === transactionRequestStatus.missingInformation()) {
                return (
                  <MissingInformationModal
                    key={item}
                    className="ms-2"
                    request={withdrawal}
                    disabled={actionLoading}
                  />
                )
              }
              if (item === transactionRequestStatus.rejected()) {
                return <RejectModal key={item} className="ms-2" request={withdrawal} disabled={actionLoading} />
              }
              if (item === transactionRequestStatus.dealersCheck()) {
                return null
              }
              if (item === transactionRequestStatus.pendingManager()) {
                return (
                  <Button
                    type="primary"
                    className="ms-2"
                    onClick={() => {
                      Modal.confirm({
                        title: 'Change status',
                        content:
                          'Are you sure you want to change the status?',
                        okText: 'Yes',
                        cancelText: 'No',
                        onOk: () => {
                          submitStatus({
                            transactionId: withdrawal.transactionId,
                            status:
                              transactionRequestStatus.cancelDealersCheck(),
                          })
                        },
                      })
                    }}
                  >
                    Pending manager
                  </Button>
                )
              }
              return (
                <Button
                  key={item}
                  style={{
                    color: buttonColorTransactionRequestStatus(item).text,
                    backgroundColor:
                      buttonColorTransactionRequestStatus(item).background,
                  }}
                  className="ms-2"
                  disabled={actionLoading}
                  loading={actionLoading}
                  onClick={() => {
                    if (
                      item != transactionRequestStatus.ps() ||
                      (item == transactionRequestStatus.ps() &&
                        window.confirm(
                          'The operation is irreversible. Are you sure you want to confirm the transaction in ' +
                          withdrawal.processingProvider +
                          '?',
                        ))
                    )
                      submitStatus({
                        transactionId: withdrawal.transactionId,
                        status: item,
                      })
                  }}
                >
                  {humanTransactionRequestStatusButton(
                    item,
                    withdrawal.processingProvider,
                  )}
                </Button>
              )
            })}
        </>
      </Guard>
    </>
  )
}
